/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 権限有無情報
 */
export interface AuthorityExistenceDto { 
    /**
     * グループコード
     */
    groupCd?: string;
    /**
     * 権限マップ … マップキー：アクションコード 値：権限（true；権限あり false:権限無し）
     */
    authorityMap?: { [key: string]: boolean; };
}

